import React from 'react';
import AppCard from './AppCard';

const AppGrid = ({ apps, columns = 3 }) => (
    <div
        className={`grid grid-cols-1 md:grid-cols-2 ${columns === 3 ? 'lg:grid-cols-3' : ''} gap-6`}
    >
        {apps.map((app, index) => (
            <AppCard key={app.id} app={app} index={index} />
        ))}
    </div>
);

export default AppGrid;
